import type { Invitation } from '../acompanantes/types'
import type { Occupant, RegistrationStay } from './types'

/**
 * Paso 1 · ocupantes (inventario D8 y D23). Personas registradas de E1 (`travelRegisteredList`), N filas
 * pendientes (`pendingToRegister`) y, sobre esas filas, las invitaciones del servicio pospuesto de acompañantes.
 * El titular es el adulto que no se puede borrar; si `mainTravelRegisterPending`, la primera fila pendiente es suya.
 */
export function buildOccupants(stay: RegistrationStay, invitations: Invitation[], registeredAt: Record<string, string> = {}, revoked: string[] = []): Occupant[] {
  const reg = stay.registration
  const registered: Occupant[] = reg.travelers.map((tr) => {
    const dataMissing = tr.missingFields.some((f) => f !== 'signature')
    return {
      id: tr.id,
      name: [tr.name, tr.surname].filter(Boolean).join(' '),
      isHolder: tr.isAdult && !tr.canDelete,
      isAdult: tr.isAdult,
      state: dataMissing || tr.signaturePending ? 'incomplete' : 'registered',
      registeredAt: registeredAt[tr.id] ?? null,
      missingFields: tr.missingFields,
      signaturePending: tr.signaturePending,
      invitation: null,
      accessRevoked: revoked.includes(tr.id),
    }
  })
  const pending: Occupant[] = []
  const invites = [...invitations]
  for (let i = 0; i < Math.max(0, reg.pending); i++) {
    const isHolder = reg.holderPending && i === 0
    const inv = isHolder ? undefined : invites.shift()
    pending.push({
      id: inv ? inv.id : `pending-${i + 1}`,
      name: inv?.name ?? null,
      isHolder,
      isAdult: true,
      state: inv ? 'invited' : 'pending',
      registeredAt: null,
      missingFields: [],
      signaturePending: false,
      invitation: inv ? { id: inv.id, channel: inv.channel, sentAt: inv.sentAt, started: inv.started } : null,
      accessRevoked: false,
    })
  }
  // El titular primero, luego registrados, luego pendientes (orden del bundle).
  return [...registered, ...pending].sort((a, b) => Number(b.isHolder) - Number(a.isHolder))
}
